import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { User } from './login/dto/user.entity';

@Injectable({
  providedIn: 'root',
})
export class AuthRepository {

  accessToken: string;

  constructor(
    private httpClient: HttpClient,
    private toastrService: NbToastrService,
  ) {
  }

  getToken(id, password, url) {
    return this.httpClient.post(`${url}/auth/login`, { document: id, password: password})
    .pipe(catchError(err => {
      if (err.status == 401) {
        return of(false);
      } else {
        this.toastrService.show(`Erro de conexão com o servidor! Status: ${err.status}`, 'Ocorreu algum erro!',
        { status: 'danger', position: NbGlobalPhysicalPosition.BOTTOM_RIGHT, duration: 10000 });
      }
      throwError(err);
    }));
  }

  getTokenValidUrl(id, password, url) {
    return this.httpClient.post(`${url}/auth/login`, { document: id, password: password })
      .pipe(catchError(err => {
        if (err.status == 401) {
          return of(false);
        } else {
          return of(true);
        }
        
      }));
  }

  getUserByHash(hash, bearer, url: string) {
    return this.httpClient.get<User>(`${url}/customers/hash/${hash}`, { headers: { Authorization: `Bearer ${bearer}` } }).toPromise();
  }
  
  passwordRecovery(userId: string, url: string): Observable<any> {
    return this.httpClient.post<any>(`${url}/user/recover/${userId}`, '').pipe(catchError(err => {
      if (err.status == 401) {
        return of(false);
      } else {
        return of(true);
      }

    }));
  }
}
